import { cn } from '@up2stay/up2promo-ui';

type SettingsPageShellProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Settings content column — stacked sections, no in-page subnav.
 * Gap follows Profiles section rhythm (16–26px → gap-6 / gap-8).
 */
export function SettingsPageShell({
  children,
  className,
}: SettingsPageShellProps) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-1 flex-col gap-6 pb-6 md:gap-7',
        className,
      )}
    >
      {children}
    </div>
  );
}
